// src/locales/ta/callCenterShifts.js
export const callCenterShifts = {
  pageTitle: 'கால் சென்டர் ஷிப்ட்கள்',
  pageDescription: 'கால் சென்டர் ஷிப்ட்களை திட்டமிடவும், ஒவ்வொரு ஊழியருக்கும் குறுக்கு-விற்பனை இலக்குகளை அமைக்கவும்',
  newShift: 'புதிய ஷிப்ட்',
  editShift: 'ஷிப்ட்டைத் திருத்து',
  createShift: 'ஷிப்ட் உருவாக்கு',
  saveShift: 'ஷிப்ட்டைச் சேமி',
  shiftDate: 'ஷிப்ட் தேதி',
  staffCount: 'ஊழியர் எண்ணிக்கை',
  totalTarget: 'மொத்த இலக்கு',
  achievedSalesValue: 'அடைந்த விற்பனை',
  totalCommission: 'மொத்த கமிஷன்',
  estimate: 'மதிப்பீடு',
  liveEstimateNote: 'இந்த மதிப்பு ஒரு நேரடி மதிப்பீடு — மாதம் இறுதி செய்யப்பட்டதும் இது நிலையானதாகும்.',
  detailsPageTitle: 'ஷிப்ட் விவரங்கள்',
  detailsPageDescription: 'ஊழியர் இலக்குகள், அடைந்த குறுக்கு-விற்பனை மதிப்பு, மற்றும் இந்த ஷிப்டிற்கான கமிஷன்',
  staffCommissionBreakdown: 'ஊழியர் கமிஷன் விவரம்',
  crossSoldItems: 'குறுக்கு-விற்கப்பட்ட பொருட்கள்',
  noCrossSellItemsForShift: 'இந்த ஷிப்டிற்கு குறுக்கு-விற்கப்பட்ட பொருட்கள் இதுவரை இல்லை',
  crossSellQuantity: 'அளவு',
  lineValue: 'வரி மதிப்பு',
  failedToLoadShiftDetails: 'ஷிப்ட் விவரங்களை ஏற்ற முடியவில்லை',
  failedToLoadCrossSellItems: 'குறுக்கு-விற்கப்பட்ட பொருட்களை ஏற்ற முடியவில்லை',
  filterByDateRange: 'ஷிப்ட் தேதி வரம்பு',
  allShiftDates: 'அனைத்து ஷிப்ட் தேதிகள்',
  noShiftsFound: 'ஷிப்ட்கள் எதுவும் இல்லை',
  noShiftsFoundDescription: 'உங்கள் வடிப்பான்களை சரிசெய்யவும் அல்லது புதிய ஷிப்ட் ஒன்றை உருவாக்கவும்',
  noShiftsYet: 'இன்னும் ஷிப்ட்கள் திட்டமிடப்படவில்லை',
  noShiftsYetDescription: 'தொடங்க உங்கள் முதல் ஷிப்ட்டை உருவாக்கவும்',
  shiftCreatedSuccess: 'ஷிப்ட் வெற்றிகரமாக உருவாக்கப்பட்டது',
  shiftUpdatedSuccess: 'ஷிப்ட் வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
  failedToLoadShifts: 'ஷிப்ட்களை ஏற்ற முடியவில்லை',
  failedToLoadUsers: 'வணிக பயனர்களை ஏற்ற முடியவில்லை',
  failedToSaveShift: 'ஷிப்ட்டை சேமிக்க முடியவில்லை',
  shiftStaff: 'ஷிப்ட் ஊழியர்கள்',
  addStaff: 'ஊழியரைச் சேர்',
  removeStaff: 'அகற்று',
  staffMember: 'ஊழியர்',
  targetValue: 'இலக்கு மதிப்பு',
  selectUser: 'ஒரு பயனரைத் தேர்ந்தெடுக்கவும்',
  edit: 'திருத்து',
  viewDetails: 'விவரங்களைக் காண்க',
  editSlabs: 'அடுக்குகளைத் திருத்து',
  commissionSlabs: 'கமிஷன் அடுக்குகள் (விற்பனை மதிப்பு அடிப்படையில்)',
  slabsHelp: 'இந்த அடுக்குகள் ஒவ்வொரு ஷிப்டிற்கும் குறுக்கு-விற்பனை கமிஷனை கணக்கிட பயன்படுத்தப்படுகின்றன. மாற்றங்கள் சேமித்த பிறகு உருவாக்கப்படும் ஷிப்ட்களுக்கு மட்டுமே பொருந்தும் — ஏற்கனவே உருவாக்கப்பட்ட ஷிப்ட்கள் அவை உருவாக்கப்பட்ட நேரத்தில் இருந்த அடுக்கு விகிதங்களை தக்க வைத்துக்கொள்ளும்.',
  addSlab: 'அடுக்கு சேர்',
  removeSlab: 'அடுக்கை அகற்று',
  saveSlabs: 'அடுக்குகளை சேமி',
  slabMinValue: 'குறைந்தபட்ச மதிப்பு',
  slabMaxValue: 'அதிகபட்ச மதிப்பு',
  slabRate: 'விகிதம் (%)',
  openEnded: 'திறந்த முடிவு',
  slabsSavedSuccess: 'கமிஷன் அடுக்குகள் வெற்றிகரமாக சேமிக்கப்பட்டன',
  failedToSaveSlabs: 'கமிஷன் அடுக்குகளை சேமிக்க முடியவில்லை',
  commissionCalculation: 'கமிஷன் கணக்கீடு',
  minValue: 'குறைந்தபட்ச மதிப்பு',
  maxValue: 'அதிகபட்ச மதிப்பு',
  amountPerUnit: 'ஒரு அலகுக்கான தொகை',
  slabQty: 'அடுக்கு அளவு',
  slabTotal: 'அடுக்கு மொத்தம்',
  noSlabsConfigured: 'இந்த ஷிப்டிற்கு கமிஷன் அடுக்குகள் அமைக்கப்படவில்லை',
  searchCrossSoldItems: 'ஆர்டர் எண் அல்லது ஏர்வேபில்லைத் தேடுங்கள்...',
  placeholders: {
    targetValue: 'e.g. 30000',
  },
  validation: {
    staffRequired: 'Add at least one staff member',
    targetRequired: 'Target value is required',
    targetPositive: 'Target value must be greater than 0',
    shiftDateRequired: 'ஷிப்ட் தேதி தேவை',
    staffUserRequired: 'ஒவ்வொரு வரிசைக்கும் ஒரு ஊழியரைத் தேர்ந்தெடுக்கவும்',
    targetValueInvalid: 'இலக்கு மதிப்பு சரியான நேர்மறை எண்ணாக இருக்க வேண்டும்',
    slabMinValueInvalid: 'குறைந்தபட்ச மதிப்பு சரியான நேர்மறை எண்ணாக இருக்க வேண்டும்',
    slabRateInvalid: 'விகிதம் சரியான நேர்மறை எண்ணாக இருக்க வேண்டும்',
    slabMaxValueRequired: 'கடைசி அடுக்கு தவிர மற்ற அனைத்து அடுக்குகளுக்கும் அதிகபட்ச மதிப்பு தேவை',
    fixErrors: 'சேமிப்பதற்கு முன் குறிப்பிடப்பட்ட பிழைகளை சரிசெய்யவும்',
  },
};
